<template>
  <path :d="pathDescription" />
</template>

<script>
export default {
  name: 'BaNodePath',
  components: {
  },
  props: {
    lineInfo: {
      type: Object,
      required: true
    },
    nodeItemBorderRadius: {
      type: Number,
      default: 0
    },
    isThruPath: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    pathDescription () {
      let { fromX, fromY, toX, toY, widthOut, widthIn } = this.lineInfo

      const trimX = fromX - this.nodeItemBorderRadius
      fromX -= trimX
      toX -= trimX

      const nodeGap = toX - fromX
      const centerX = fromX + nodeGap / 2
      const borderRadius = this.nodeItemBorderRadius
      const description = []

      fromX -= borderRadius
      toX += borderRadius

      const moveValue = nodeGap * 0.125
      description.push(
        'M', fromX, fromY,
        'L', fromX + borderRadius + moveValue, fromY,
        'C', centerX, fromY, centerX, toY, toX - moveValue, toY,
        'L', toX, toY, toX, toY + widthIn, toX - moveValue, toY + widthIn,
        'C', centerX, toY + widthIn, centerX, fromY + widthOut, fromX + borderRadius + moveValue, fromY + widthOut,
        'L', fromX, fromY + widthOut,
        'Z'
      )

      return description.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
